import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=862b7b88&scoped=true&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862b7b88",
  null
  
)

export default component.exports